var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zgq-container"},[(_vm.total > 0 || _vm.scrollFlag)?[_vm._l((_vm.blockList),function(item){return _c('Block',{key:item.id,attrs:{"block":item}})}),_c('Scroll',{attrs:{"scrollFlag":_vm.scrollFlag,"isEnd":_vm.isEnd}})]:_vm._e(),(_vm.total <= 0 && !_vm.scrollFlag)?_c('NoData',{staticStyle:{"left":"0"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }